import { Product } from "../types/order";

export const getProductQuantity = (product_ids: string[], products: Product[]): number => {
    // get total quantity for the given product IDs
    let totalQuantity = 0;
    product_ids.forEach((pid) => {
        const product = products.find((p) => p.id === pid);
        if (product) {
            totalQuantity += product.quantity;
        }
    });
    return totalQuantity;
}

export const all_doc_List=[
  { "id": 5, "filename": "Offer Letter", "doc_id": 5, "type": "personal" },
  { "id": 8, "filename": "Return flight tickets", "doc_id": 8, "type": "travel" },
  { "id": 9, "filename": "Visa", "doc_id": 9, "type": "travel" },
  { "id": 13, "filename": "GIC Letter", "doc_id": 13, "type": "personal" },
  { "id": 21, "filename": "I20 (In case of USA colleges)", "doc_id": 20, "type": "travel" },
  { "id": 37, "filename": "Parent Pan Card (if payment by them)", "doc_id": 36, "type": "personal" },
  { "id": 50, "filename": "Cancelled Cheque", "doc_id": 49, "type": "personal" },
  { "id": 53, "filename": "Arrival travel ticket", "doc_id": 52, "type": "travel" },
  { "id": 52, "filename": "Bank Account Status", "doc_id": 51, "type": "personal" },
  { "id": 1, "filename": "Pan Card", "doc_id": 1, "type": "personal" },
  { "id": 2, "filename": "Aadhaar Card", "doc_id": 2, "type": "personal" },
  { "id": 3, "filename": "Passport Front", "doc_id": 3, "type": "travel" },
  { "id": 4, "filename": "Passport Back", "doc_id": 4, "type": "travel" },
  { "id": 51, "filename": "Passbook", "doc_id": 50, "type": "personal" },
  { "id": 6, "filename": "First Instruction Letter", "doc_id": 6, "type": "personal" },
  { "id": 7, "filename": "Second Instruction Letter", "doc_id": 7, "type": "personal" },
  { "id": 10, "filename": "LERMS letter", "doc_id": 10, "type": "personal" },
  { "id": 15, "filename": "Student Residence Address", "doc_id": 14, "type": "personal" },
  { "id": 16, "filename": "Account Details", "doc_id": 15, "type": "personal" },
  { "id": 17, "filename": "Bank Address", "doc_id": 16, "type": "personal" },
  { "id": 18, "filename": "FormA2", "doc_id": 17, "type": "personal" },
  { "id": 19, "filename": "Loan Disbursement Letter", "doc_id": 18, "type": "personal" },
  { "id": 20, "filename": "Admission Letter from University", "doc_id": 19, "type": "travel" },
  { "id": 22, "filename": "Remitter PAN Card", "doc_id": 21, "type": "personal" },
  { "id": 23, "filename": "Payer Aadhar Card", "doc_id": 22, "type": "personal" },
  { "id": 49, "filename": "PAN of Traveller", "doc_id": 48, "type": "personal" },
  { "id": 25, "filename": "Payer Pan Card", "doc_id": 24, "type": "personal" },
  { "id": 26, "filename": "Student Passport", "doc_id": 25, "type": "travel" },
  { "id": 27, "filename": "Student VISA", "doc_id": 26, "type": "travel" },
  { "id": 28, "filename": "Student Account Details", "doc_id": 27, "type": "personal" },
  { "id": 29, "filename": "Receiver Bank Address", "doc_id": 28, "type": "personal" },
  { "id": 30, "filename": "Receiver Passport", "doc_id": 29, "type": "travel" },
  { "id": 31, "filename": "Receiver Residence Address", "doc_id": 30, "type": "personal" },
  { "id": 32, "filename": "Receiver Account Details", "doc_id": 31, "type": "personal" },
  { "id": 33, "filename": "Student Passport Front & Last Page", "doc_id": 32, "type": "travel" },
  { "id": 34, "filename": "Remitter ID Address Proof", "doc_id": 33, "type": "personal" },
  { "id": 35, "filename": "Student Pan Card", "doc_id": 34, "type": "personal" },
  { "id": 36, "filename": "Foreign Education Loan Agreement", "doc_id": 35, "type": "personal" },
  { "id": 38, "filename": "Valid University Offer Letter with Visa", "doc_id": 37, "type": "travel" },
  { "id": 39, "filename": "Sponsorship Letter", "doc_id": 38, "type": "personal" },
  { "id": 40, "filename": "Loan Disbursement Letter", "doc_id": 39, "type": "personal" },
  { "id": 41, "filename": "Instruction Letter", "doc_id": 40, "type": "personal" },
  { "id": 42, "filename": "Cheque", "doc_id": 41, "type": "personal" },
  { "id": 43, "filename": "AD1 Form", "doc_id": 42, "type": "personal" },
  { "id": 44, "filename": "Vernacular Name Declaration", "doc_id": 43, "type": "personal" },
  { "id": 45, "filename": "Beneficiary Residence Address", "doc_id": 44, "type": "personal" },
  { "id": 46, "filename": "Passbook front page", "doc_id": 45, "type": "personal" },
  { "id": 47, "filename": "Passbook back page", "doc_id": 46, "type": "personal" },
  { "id": 48, "filename": "Passport Front and back Page", "doc_id": 47, "type": "travel" },
  { "id": 24, "filename": "Passport", "doc_id": 23, "type": "travel" }
]
